export default "__VITE_ASSET__7a72ed7d__"